import getBrandName from '@/services/app-branding/helpers/getBrandName';
import hasWinckBranding from '@/services/app-branding/helpers/hasWinckBranding';
import hasHeylohaBranding from '@/services/app-branding/helpers/hasHeylohaBranding';

export default function useAppBranding() {
    const appBrand = getBrandName();

    return {
        appBrand,
        hasWinckBranding,
        hasHeylohaBranding,
    };
}
